import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { initGA, trackPageView } from './utils/analytics';
import { hasUserRespondedToConsent, setConsent } from './utils/consent';
import ConsentAlert from './Components/ConsentAlert/ConsentAlert';

import Home from './Components/Pages/Home';
import Contact from './Components/Pages/Contact';
import About from './Components/Pages/About';
import Category from './Components/Pages/Category';
import Article from './Components/Pages/Article';
import AllArticles from './Components/Pages/AllArticles';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';
import TermsAndConditions from './Components/Pages/TermsAndConditions';
import CookiePolicy from './Components/Pages/CookiePolicy';
import HealthDisclaimer from './Components/Pages/HealthDisclaimer'

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
}

function App() {
  const [showConsentAlert, setShowConsentAlert] = useState(false);

  useEffect(() => {
    if (hasUserRespondedToConsent()) {
      initGA();
    } else {
      setShowConsentAlert(true);
    }
  }, []);

  const handleAcceptConsent = () => {
    setConsent(true);
    setShowConsentAlert(false);
    initGA();
  };

  const handleDeclineConsent = () => {
    setConsent(false);
    setShowConsentAlert(false);
  };

  return (
    <div className="App">
      {showConsentAlert && (
        <ConsentAlert
          onAccept={handleAcceptConsent}
          onDecline={handleDeclineConsent}
        />
      )}
      <Router>
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/articles" element={<AllArticles />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/category/:categorySlug" element={<Category />} />
          <Route path="/article/:articleId" element={<Article />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/health-disclaimer" element={<HealthDisclaimer />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
